import { dataHooks } from '@wix/data-hooks';

export const attachmentsPreviewDataHooks = dataHooks<{
  imageViewer;
  mediaOverlay;
  image;
  deleteButton;
  duration: { name: string };
}>('AttachFile');
